<template>
  <div class="bg-white" :class="!inModal ? 'full-page-overlay' : ''" >
    <b-container>
      <b-row align-h="center">
        <b-col cols="12" :md="!inModal ? 8 : 12" :lg=" !inModal ? 6 : 12">
          <div v-if="!inModal">
            <br><br><br><br><br>
            <div v-if="stillNotEnough">
              <h2 class="mb-3" v-translate>Your ongoing operations spent more credit than the amount you just added :(</h2>
              <h3 v-translate>You still need to add some credit to be able to create shippings again.</h3>
              <p v-translate>Hint: If your company has a big daily operation you should think about to add more credit than the minimum suggested payment.</p>
            </div>
            <div v-else>
              <h1 class="mb-3" v-translate>Your account has reached the credit limit and cannot continue operating.</h1>
              <h2 v-translate>You need to add some credit to be able to create shippings again.</h2>
            </div>
          </div>
          <div v-else>
            <p><strong v-translate>Your account has reached the credit limit and cannot continue operating.</strong></p>
            <p><strong v-translate>You need to add some credit to be able to create shippings again.</strong></p>
          </div>

          <div class="company-balance" :class="!inModal ? 'my-5' : 'mb-5'">
            <b-alert show>
              <b-row>
                <b-col md="6" align-self="end" class="text-center">
                  <h5 v-translate>Current Company Balance</h5>
                  <h2 class="mb-0">{{$store.getters.profile.company.account.balance | currency($store.getters.profile.company.country_iso_code)}}</h2>
                  <h5><small><small v-translate>(VAT not incl.)</small></small></h5>
                </b-col>
                <b-col md="6" align-self="end" class="text-center">
                  <h5 v-translate>Minimum credit needed to continue operating</h5>
                  <h2 class="mb-0">{{minCreditToOperate | currency($store.getters.profile.company.country_iso_code)}}</h2>
                  <h5><small v-translate>+ VAT</small></h5>
                </b-col>
              </b-row>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col cols="12" :md="!inModal ? 8 : 12" :lg="!inModal ? 4 : 8">
          <add-credit-form v-if="isCompanyAdmin" />
          <div v-else>
            <b-alert variant="warning" show>
              <p class="m-0" v-translate>You don't have permissions to add Company credit. Please ask your Company Administrator to do it.</p>
            </b-alert>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AddCreditForm from '@/components/AddCreditForm'

export default {
  components: {
    AddCreditForm
  },
  props: {
    inModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      countryThreshold: window.countries.find(x => x.iso_code === this.$store.getters.profile.country_iso_code).credit_threshold,
      paymentProvider: {
        name: 'MercadoPago',
        slug: 'mercado-pago'
      },
      stillNotEnough: false
    }
  },
  computed: {
    minCreditToOperate() {
      if (this.$store.getters.profile.company.account.balance > 0 && this.$store.getters.profile.company.account.balance < this.countryThreshold) {
        return Number((Math.round((Math.abs(this.countryThreshold - this.$store.getters.profile.company.account.balance + this.$store.getters.profile.company.account.credit_limit)) * 100) / 100).toFixed(2))
      }
      return Number((Math.round((Math.abs(this.$store.getters.profile.company.account.balance) + this.$store.getters.profile.company.account.credit_limit + this.countryThreshold) * 100) / 100).toFixed(2))
    }
  },
  mounted() {
    if (this.$route.query.payment_id && this.$route.query.status === 'approved') {
      this.stillNotEnough = true
    }
  }
}
</script>

<style lang="scss">
.full-page-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  z-index: 1029;
}
</style>
